"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wizard = exports.validator = void 0;
var validator = ["AB", "BC", "MB", "NB", "NL", "NT", "NS", "NU", "ON", "PE", "QC", "SK", "YT"];
exports.validator = validator;
var wizard = ['Western Australia', 'Alberta', 'British Columbia', 'Manitoba', 'New Brunswick', 'Newfoundland And Labrador', 'Northwest Territories', 'Nova Scotia', 'Nunavut', 'Ontario', 'Prince Edward Island', 'Quebec', 'Saskatchewan', 'Yukon'];
exports.wizard = wizard;
//# sourceMappingURL=states_CA.js.map